import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class CeremonyChannelSubscription {
  public subscription: Subscription;

  constructor(orchestratorId: number, { received, connected = undefined, disconnected = undefined }, votingRoundReportId?: number) {
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: 'CeremonyChannel',
        orchestrator_id: orchestratorId,
        voting_round_report_id: votingRoundReportId
      },
      {
        received,
        connected,
        disconnected,
      },
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }

  fetchStatus() {
    this.subscription.perform('status');
  }
}